import React, { useEffect, useState } from "react";
import {
    TextField,
    Checkbox,
    FormControlLabel,
    Autocomplete,
    Box,
    Grid,
    Typography
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import dayjs from "dayjs";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";

const DynamicFormByCategory = ({ selectedCategoryId, selectedSubCategoryID, formData, setFormData,  }) => {
    const [attributes, setAttributes] = useState([]);


    useEffect(() => {
        if (selectedCategoryId) {
            const requestBody = {
                IdCategory: selectedCategoryId === 0 ? null : selectedCategoryId,
                IdSubCategory: selectedSubCategoryID === 0 ? null : selectedSubCategoryID,
            };

            callApi(API_ENDPOINTS.MATERIAL_ATTRIBUTE_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, requestBody)
                .then(data => {
                    if (data && data.length > 0) {
                        setAttributes(data);
                    }
                    else {
                        setAttributes([]);
                        setFormData({});
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [selectedCategoryId, selectedSubCategoryID]);

    const handleChange = (attrName, value) => {
        setFormData(prev => ({
            ...prev,
            [attrName]: value,
        }));
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>

            {attributes.map(attr => {
                if (!attr.is_active) return null;

                const key = attr.attribute_name;
                const label = attr.ui_label;
                const required = attr.is_required;

                switch (attr.ui_type) {
                    case "textbox":
                        return (
                            <Grid item key={key} xs={12} xl={12} >

                                <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                                    <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1.8} display="flex-start" justifyContent="center" >
                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                            {label}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                                        <TextField
                                            fullWidth
                                            label={label}
                                            size="small"
                                            name={key}
                                            color="secondary"
                                            required={required}
                                            value={formData[key] || ""}
                                            onChange={(e) => handleChange(key, e.target.value)}
                                            type={attr.data_type === "number" ? "number" : "text"}
                                        />



                                    </Grid>

                                </Grid>
                            </Grid>




                        );

                    case "checkbox":
                        return (
                            <Grid item key={key} xs={12} xl={12} >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color="secondary"
                                            checked={formData[key] || false}
                                            onChange={(e) => handleChange(key, e.target.checked)}
                                        />
                                    }
                                    label={label}
                                />
                            </Grid>
                        );

                    case "autocomplete":
                        const options = attr.options?.split(",") || []; // if coming as comma-separated
                        return (
                            <Grid item key={key} xs={12} xl={12} >
                                <Autocomplete
                                    fullWidth
                                    options={options}
                                    value={formData[key] || ""}
                                    onChange={(e, newVal) => handleChange(key, newVal)}
                                    renderInput={(params) => (
                                        <TextField size="small" {...params} label={label} required={required} />
                                    )}
                                />
                            </Grid>
                        );

                    case "datepicker":
                        return (
                            <Grid item key={key} xs={12} xl={12} >
                                <DatePicker
                                    label={label}
                                    value={formData[key] ? dayjs(formData[key]) : null}
                                    onChange={(newVal) =>
                                        handleChange(key, newVal ? newVal.format("YYYY-MM-DD") : "")
                                    }
                                    slotProps={{ textField: { fullWidth: true, required } }}
                                />
                            </Grid>
                        );

                    default:
                        return null;
                }
            })}

        </LocalizationProvider>
    );
};

export default DynamicFormByCategory;
